import { config as appConfig } from "@/app/config";

export const authConfig = {
    /**
     * Sanctum CSRF bootstrap endpoint.
     * Must be called before any mutating SPA request to obtain the XSRF-TOKEN cookie.
     * Spec ref: AC-1
     */
    sanctumCsrfUrl: `${appConfig.platformUrl}/sanctum/csrf-cookie`,
};
